<template>
  <div>
    <!-- page-wrapper Start-->
    <div
      id="canvas-bookmark"
      class="page-wrapper"
    >
      <!-- Page Header Start-->
      <div
        class="page-main-header"
        :class="{ open:toggle_sidebar_var }"
      >
        <div class="main-header-right row">
          <div class="main-header-left d-lg-none">
            <div class="logo-wrapper">
              <router-link :to="{ name: 'welcome'}">
                <img
                  src="../assets/images/color_logo.png"
                  alt=""
                >
              </router-link>
            </div>
          </div>
          <div class="mobile-sidebar">
            <div class="media-body text-right switch-sm">
              <label
                class="header-icon cursor-pointer"
                @click="toggle_sidebar"
              >
                <img
                  src="@/assets/images/icons/menu.png"
                  :alt="$t('header.menu')"
                >
              </label>
            </div>
          </div>
          <div class="nav-right col">
            <ul
              class="nav-menus"
              :class="{ open: mobile_toggle }"
            >
              <li v-if="sessionType !== 'personal'">
                <form
                  class="form-inline search-form"
                  @submit.prevent="submitSearch"
                >
                  <div class="form-group">
                    <input
                      v-model="terms"
                      :class="{ open: mobile_search }"
                      class="form-control-plaintext"
                      type="search"
                      :placeholder="$t('header.axtar')"
                      @keyup="searchTerm"
                    >

                    <span
                      class="d-sm-none"
                      @click="mobile_search = !mobile_search"
                    >
                      <feather type="search" />
                    </span>
                  </div>
                </form>
              </li>
              <!-- <li><a href="javascript:void(0)" class="text-dark" v-on:click="toggle_fullscreen()">
                <feather type="maximize"></feather>
              </a></li>-->
              <li>
                <div>
                  <button
                    class="btn btn-light-info rounded-pill px-3 "
                    style="white-space: nowrap"
                    @click.prevent="$bvModal.show('modal-request-create')"
                  >
                    <i class="fa fa-plus text-primary mr-1" />
                    {{ $t('body.soruYarat') }}
                  </button>
                </div>
              </li>
              <LocaleChanger />
              <li
                v-if="sessionType !== 'personal'"
                class="onhover-dropdown"
              >
                <div class="header-icon">
                  <img
                    v-if="notificationCount>0"
                    src="@/assets/images/icons/notification-alert.png"
                    alt=""
                  >
                  <img
                    v-else
                    src="@/assets/images/icons/notification-empty.png"
                    alt="empty-not"
                  >
                </div>
                <ul
                  class="notification-dropdown onhover-show-div"
                  style="max-height: 90vh; overflow: auto"
                >
                  <li class="d-flex justify-content-between">
                    <strong>
                      {{ $t('header.bildiririlr') }}
                      <span
                        v-if="notificationCount"
                        class="badge badge-pill badge-primary"
                      >
                        {{ notificationCount }}
                      </span>
                    </strong>
                    <a
                      v-if="notificationCount>0"
                      href="#"
                      class="ml-1 btn btn-sm py-2 btn-light-primary"
                      @click.prevent="markAllRead"
                    >
                      {{ $t('header.oxunmuKimiQeydEt') }}
                    </a>
                  </li>
                  <li v-if="notificationCount===0">
                    <i
                      class="fa fa-check"
                      aria-hidden="true"
                    /> {{ $t('header.oxunmamBildiriinizYoxdur') }}
                  </li>
                  <li
                    v-for="n in notifications"
                    :key="n.id"
                  >
                    <template v-if="n.target==='request'">
                      <NotificationConversationStarted
                        v-if="n.action==='CONVERSATION_STARTED'"
                        :notification="n"
                      />
                      <a
                        v-else
                        class="notification-item"
                        :href="`/dashboard/request/${n.request.id}`"
                      >
                        <div class="d-flex justify-content-between">
                          <div class="w-100">
                            <div class="title">
                              #{{ n.request.requestType }}{{ buildLongId(n.request.id) }}
                            </div>
                            <div
                              class="body"
                              v-html="getNotificationMessage(n)"
                            />
                            <div class="time">
                              {{ $t('dashboardCompany.key', {moment: getMoment(n.logTime)}) }}
                            </div>
                          </div>
                          <div
                            v-if="n.status===0"
                            class="dott"
                          />
                        </div>
                      </a>
                    </template>
                    <div
                      v-else-if="n.target==='announcement'"
                      class="media"
                      @click.prevent="$router.push({name: 'announcement', params:{id: n.announcement.id}})"
                    >
                      <div class="media-body">
                        <h6 class="mt-0">
                          <span :class="{'text-secondary':n.status>0}">
                            <strong>{{ n.announcement.title }}</strong>
                          </span>
                          <small class="pull-right">
                            {{ $t('dashboardCompany.key', {moment: getMoment(n.logTime)}) }}
                          </small>
                          <div class="mb-0">
                            {{ $t('header.yeniElanVar') }}
                          </div>
                        </h6>
                      </div>
                    </div>
                    <div
                      v-else-if="n.target==='company'"
                      class="media"
                      @click.prevent="$router.push({name: 'companyProfile'})"
                    >
                      <div class="media-body">
                        <h6 class="mt-0">
                          <span :class="{'text-secondary':n.status>0}">
                            <strong>{{ n.company?.name }} {{ getCompanyFormat(n.company?.format) }}</strong>
                          </span>

                          <small class="pull-right">
                            {{ $t('dashboardCompany.key', {moment: getMoment(n.logTime)}) }}
                          </small>
                          <p
                            class="mb-0"
                            v-html="getNotificationMessage(n)"
                          />
                        </h6>
                      </div>
                    </div>
                    <div
                      v-else-if="n.target==='form'"
                      class="media"
                      @click.prevent="formNotificationClick(n)"
                    >
                      <div class="media-body">
                        <h6 class="mt-0">
                          <span :class="{'text-secondary':n.status>0}">
                            <strong>{{ n.companyForm.name }}</strong>
                          </span>

                          <small class="pull-right">
                            {{ $t('dashboardCompany.key', {moment: getMoment(n.logTime)}) }}
                          </small>
                          <p
                            class="mb-0"
                            v-html="getNotificationMessage(n)"
                          />
                        </h6>
                      </div>
                    </div>
                    <div
                      v-else-if="n.target==='form_request'"
                      class="media"
                      @click.prevent="formRequestNotificationClick(n)"
                    >
                      <div class="media-body">
                        <h6 class="mt-0">
                          <span :class="{'text-secondary':n.status>0}">
                            <strong>{{ n.companyForm.name }}</strong>
                          </span>

                          <small class="pull-right">
                            {{ $t('dashboardCompany.key', {moment: getMoment(n.logTime)}) }}
                          </small>
                          <p
                            class="mb-0"
                            v-html="getNotificationMessage(n)"
                          />
                        </h6>
                      </div>
                    </div>
                    <div
                      v-else-if="n.target==='product_inquiry'"
                      class="media"
                      @click.prevent="handleProductClick()"
                    >
                      <div class="d-flex justify-content-between">
                        <div class="w-100">
                          <div class="title">
                            {{ n.products.name }} #{{ buildLongId(n.products.id) }}
                          </div>
                          <div
                            class="body"
                            v-html="getNotificationMessage(n)"
                          />
                          <div class="time">
                            {{ $t('dashboardCompany.key', {moment: getMoment(n.logTime)}) }}
                          </div>
                        </div>
                        <div
                          v-if="n.status===0"
                          class="dott"
                        />
                      </div>
                    </div>
                    <div v-else-if="n.target==='product'">
                      <div
                        class="media-body"
                        @click.prevent="handleProductIdClick(n.products.id)"
                      >
                        <h6 class="mt-0">
                          <small class="pull-right">
                            {{ $t('dashboardCompany.key', {moment: getMoment(n.logTime)}) }}
                          </small>
                          <p
                            class="mb-0"
                            v-html="getNotificationMessage(n)"
                          />
                        </h6>
                      </div>
                    </div>
                    <div
                      v-else-if="n.target==='payment'"
                      class="media"
                      @click.prevent="$router.push({name: 'invoicesPage'})"
                    >
                      <div class="media-body">
                        <h6 class="mt-0">
                          <span :class="{'text-secondary':n.status>0}">
                            <strong>{{ $t('header.dniMlumat') }}</strong>
                          </span>

                          <small class="pull-right">
                            {{ $t('dashboardCompany.key', {moment: getMoment(n.logTime)}) }}
                          </small>
                          <p
                            class="mb-0"
                            v-html="getNotificationMessage(n)"
                          />
                        </h6>
                      </div>
                    </div>
                    <div
                      v-else-if="n.target==='verifyCompany'"
                      class="media"
                      @click.prevent="$router.push({name: 'companyProfile'})"
                    >
                      <div class="media-body">
                        <h6 class="mt-0">
                          <span :class="{'text-secondary':n.status>0}">
                            <strong>Şirkət məlumatlarının təsdiqlənməsi haqqda</strong>
                          </span>

                          <small class="pull-right">
                            {{ $t('dashboardCompany.key', {moment: getMoment(n.logTime)}) }}
                          </small>
                          <p
                            class="mb-0"
                            v-html="getNotificationMessage(n)"
                          />
                        </h6>
                      </div>
                    </div>

                    <div
                      v-else-if="n.target==='custom'"
                      class="media"
                      @click.prevent="markOneRead(n)"
                    >
                      <div class="media-body">
                        <h6 class="mt-0">
                          <small class="pull-right">
                            {{ $t('dashboardCompany.key', {moment: getMoment(n.logTime)}) }}
                          </small>
                          <p
                            class="mb-0"
                            v-html="getNotificationMessage(n)"
                          />
                        </h6>
                      </div>
                    </div>
                    <div
                      v-else-if="n.target==='blacklist_add'"
                      class="media"
                      @click.prevent="$router.push({name: 'vendorManagementOutgoingRequests'})"
                    >
                      <div class="media-body">
                        <h6 class="mt-0">
                          <span :class="{'text-secondary':n.status>0}">
                            <strong>{{ $t('notification.blacklist_added') }}</strong>
                          </span>
                        </h6>
                      </div>
                    </div>

                    <div
                      v-else-if="n.target==='blacklist_remove'"
                      class="media"
                      @click.prevent="$router.push({name: 'vendorManagementOutgoingRequests'})"
                    >
                      <div class="media-body">
                        <h6 class="mt-0">
                          <span :class="{'text-secondary':n.status>0}">
                            <strong>{{ $t('notification.blacklist_remove') }}</strong>
                          </span>
                        </h6>
                      </div>
                    </div>

                    <div
                      v-else-if="n.target==='deleted_vendor'"
                      class="media"
                      @click.prevent="$router.push({name: 'vendorManagementOutgoingRequests'})"
                    >
                      <div class="media-body">
                        <h6 class="mt-0">
                          <span :class="{'text-secondary':n.status>0}">
                            <strong>{{ $t('notification.vendor_deleted') }}</strong>
                          </span>
                          <small class="pull-right">
                            {{ $t('dashboardCompany.key', {moment: getMoment(n.logTime)}) }}
                          </small>
                        </h6>
                      </div>
                    </div>

                    <div
                      v-else-if="n.target==='deleted_deleted_vendor'"
                      class="media"
                      @click.prevent="$router.push({name: 'vendorManagementOutgoingRequests'})"
                    >
                      <div class="media-body">
                        <h6 class="mt-0">
                          <span :class="{'text-secondary':n.status>0}">
                            <strong>{{ $t('notification.vendor_deleted_finally') }}</strong>
                          </span>
                          <small class="pull-right">
                            {{ $t('dashboardCompany.key', {moment: getMoment(n.logTime)}) }}
                          </small>
                        </h6>
                      </div>
                    </div>

                    <div
                      v-else-if="n.target==='vendor'"
                      class="media"
                      @click.prevent="$router.push({name: 'vendorManagementOutgoingRequests'})"
                    >
                      <div class="media-body">
                        <h6 class="mt-0">
                          <span :class="{'text-secondary':n.status>0}">
                            <strong>{{ $t('notification.vendor_added') }}</strong>
                          </span>
                          <small class="pull-right">
                            {{ $t('dashboardCompany.key', {moment: getMoment(n.logTime)}) }}
                          </small>
                          <p
                            class="mb-0"
                            v-html="getNotificationMessage(n)"
                          />
                        </h6>
                      </div>
                    </div>

                    <div
                      v-else-if="n.target==='user_reject'"
                      class="media"
                    >
                      <div class="media-body">
                        <h6 class="mt-0">
                          <span :class="{'text-secondary':n.status>0}">
                            <strong>{{ $t('notification.user_rejected') }}</strong>
                          </span>
                          <small class="pull-right">
                            {{ $t('dashboardCompany.key', {moment: getMoment(n.logTime)}) }}
                          </small>
                          <p
                            class="mb-0"
                            v-html="getNotificationMessage(n)"
                          />
                        </h6>
                      </div>
                    </div>

                    <div
                      v-else
                      class="media"
                      @click.prevent="markOneRead(n)"
                    >
                      <div class="media-body">
                        <h6 class="mt-0">
                          <!--                          <span :class="{'text-secondary':n.status>0}">-->
                          <!--                            <strong>{{ n.target }}: {{ n.action }}</strong>-->
                          <!--                          </span>-->

                          <small class="pull-right">
                            {{ $t('dashboardCompany.key', {moment: getMoment(n.logTime)}) }}
                          </small>
                          <p
                            class="mb-0"
                            v-html="getNotificationMessage(n)"
                          />
                        </h6>
                      </div>
                    </div>
                  </li>
                </ul>
              </li>
              <li>
                <a
                  v-if="sessionType !== 'personal'"
                  href="#"
                  @click.prevent="$router.push({name: 'conversationList'})"
                >
                  <div class="header-icon">
                    <img
                      v-if="messageCount>0"
                      src="@/assets/images/icons/message-alert.png"
                    >
                    <img
                      v-else
                      src="@/assets/images/icons/message-empty.png"
                    >
                  </div>

                </a>
              </li>
              <li class="onhover-dropdown">
                <div class="header-profile-icon">
                  <img
                    :src="getImgUrl()"
                    alt="header-user"
                  >

                  {{ user.name }} {{ user.surname.substring(0, 1) }}.

                  <i class="fa fa-angle-down" />
                </div>
                <ul class="profile-dropdown onhover-show-div p-20">
                  <li>
                    <router-link :to="{name: 'userProfile'}">
                      <feather type="user" />
                      {{ $t('header.profil') }}
                    </router-link>
                  </li>

                  <li @click="logout">
                    <a href="#">
                      <feather type="log-out" />
                      {{ $t('passwordChange.x') }}
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
            <div
              class="d-lg-none mobile-toggle pull-right"
              @click="mobile_toggle = !mobile_toggle"
            >
              <feather type="more-horizontal" />
            </div>
          </div>
        </div>
      </div>
      <!-- Page Header Ends -->
    </div>
  </div>
</template>
<script>
import {mediaBase} from "@/repositories/Repository";
import {mapState} from "vuex";
import {getMyNotifications, readAllNotifications} from "@/repositories/GeneralDataRepository";
import {buildLongId, getCompanyFormat} from "@/repositories/Utils";
import NotificationConversationStarted from "@/components/notification/NotificationConversationStarted.vue";
import moment from "moment/moment";
import LocaleChanger from "@/components/locale_changer.vue";

var body = document.getElementsByTagName("body")[0];

export default {
  name: 'Search',
  components: {LocaleChanger, NotificationConversationStarted},
  data() {
    return {
      notifications: [],
      terms: '',
      searchResult: false,
      searchResultEmpty: false,
      toggle_sidebar_var: false,
      clicked: false,
      toggle_rightsidebar_var: false,
      rightclicked: false,
      mobile_toggle: false,
      mobile_search: false,
      search: []
    }
  },
  computed: {
    moment() {
      return moment
    },
    ...mapState({
      menuItems: state => state.menu.data,
      user: state => state.auth.user,
      profile: state => state.auth.profile,
      company: state => state.auth.company,
      notificationCount: state => state.auth.notificationCount,
      messageCount: state => state.auth.messageCount,
      sessionType: state => state.auth.sessionType,
      token: state => state.auth.token
    }),
  },
  watch: {
    search: function () {
      this.terms ? this.addFix() : this.removeFix();
      this.searchResultEmpty = !this.search.length;
    },
    "$route"() {
      this.terms = this.$route.query['keyword'];
    }
  },
  mounted() {
    this.getNotifications();

    setInterval(() => {
      this.getNotifications();
    }, 5000);
    this.terms = this.$route.query['keyword'];
  },
  methods: {
    handleProductClick() {
      this.$router.push({name: 'myProductsPage'}).then(() => {
        this.$nextTick(() => {
          const target = document.getElementById('targetProductInquiry');
          if (target) {
            target.scrollIntoView({behavior: 'smooth'});
          }
        });
      });

    },
    handleProductIdClick(id) {
      this.$router.push({name: 'product', params: {id: id}}).then(() => {
        this.$nextTick(() => {
          const target = document.getElementById('targetProductInquiry');
          if (target) {
            target.scrollIntoView({behavior: 'smooth'});
          }
        });
      });

    },
    getMoment(time) {
      moment.locale(this.$i18n.locale);
      return moment(new Date(time)).format('DD MMM YYYY HH:mm')
    },
    getImgUrl() {
      return (this.user && this.user.photo ? mediaBase + '/thumbnailCropped' + this.user.photo : require("../assets/images/dashboard/user.png"))
    },
    searchTerm: function () {
      // this.$store.dispatch('menu/searchTerm', this.terms)
      let items = [];
      this.terms = this.terms.toLowerCase();
      this.menuItems.filter(menuItems => {
        if (menuItems.title.toLowerCase().includes(this.terms) && menuItems.type === 'link') {
          items.push(menuItems);
        }
        if (!menuItems.children) return false
        menuItems.children.filter(subItems => {
          if (subItems.title.toLowerCase().includes(this.terms) && subItems.type === 'link') {
            subItems.icon = menuItems.icon
            items.push(subItems);
          }
          if (!subItems.children) return false
          subItems.children.filter(suSubItems => {
            if (suSubItems.title.toLowerCase().includes(this.terms)) {
              suSubItems.icon = menuItems.icon
              items.push(suSubItems);
            }
          })
        })
        this.search = items
      });
    },
    logout: function () {
      localStorage.removeItem("token");
      if (localStorage.getItem("asanLogin") === "yes") {

        localStorage.removeItem("asanLogin");
        window.location.href = 'https://asan.scc.az/logout.php'

      } else {
        this.$store.dispatch("auth/setUser", null)
        this.$router.replace('/auth/login');
      }
    },
    addFix() {
      body.classList.add("offcanvas")
      this.searchResult = true;
    },
    removeFix() {
      body.classList.remove("offcanvas")
      this.searchResult = false;
      this.terms = ''
    },
    toggle_sidebar() {
      this.toggle_sidebar_var = !this.toggle_sidebar_var,
          this.clicked = !this.toggle_sidebar_var,
          this.$emit('clicked', this.clicked)
    },
    toggle_rightsidebar() {
      this.toggle_rightsidebar_var = !this.toggle_rightsidebar_var,
          this.rightclicked = !this.toggle_rightsidebar_var,
          this.$emit('rightclicked', this.rightclicked)
    },
    toggle_fullscreen() {
      if ((document.fullScreenElement && document.fullScreenElement !== null) ||
          (!document.mozFullScreen && !document.webkitIsFullScreen)) {
        if (document.documentElement.requestFullScreen) {
          document.documentElement.requestFullScreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullScreen) {
          document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    getNotifications() {
      if (this.sessionType !== 'personal') {
        getMyNotifications(this.token, 1).then(d => {
          if (d && d.code === 200) {
            this.notifications = d.notifications;
            this.$store.dispatch('auth/setNotificationCount', d.notificationCount);
            this.$store.dispatch('auth/setMessageCount', d.messageCount);
          }
        })
      } else {
        this.notifications = [];
      }
    }, buildLongId(id) {
      return buildLongId(id, 5);
    },
    getNotificationMessage(n) {
      let json = JSON.parse(n.data);
      let messageKey = `notification.${json.action.toLowerCase()}`;

      // Prepare the data for interpolation in the translation string
      let messageData = {
        title: n.request ? n.request.title : '',
        user: json.user ? json.user : '',
        winner: json.winner ? json.winner : '',
        position: json.position ? json.position : '',
        company: json.company ? json.company : '',
        product: json.productName ? json.productName : '',
      };
      return this.$t(messageKey, messageData);
    },
    markAllRead() {

      if (confirm(this.$t("generalModal.markAsRead"))) {
        readAllNotifications(this.token, 0).then(data => {

          if (data.code === 200) {
            this.$swal({
              title: this.$t("generalModal.successTitle"),
              text: this.$t("notification.markedAsRead"),
              icon: 'success'
            })
          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }

        })
      }

    },
    markOneRead(notification) {

      readAllNotifications(this.token, notification.id).then(data => {

        if (data.code === 200) {

          let json = JSON.parse(notification.data);

          this.$swal({
            title: `${json['title']}`,
            text: `${json.body}`,
            icon: 'info'
          })
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }

      })

    },
    formRequestNotificationClick(notification) {
      if (notification.action==='INVITE_FORM_USER') {
        this.$router.push({name: 'vendorFormView', params: {id: notification.companyForm.id}});
      }
      if (notification.companyForm.company.id === this.company.id && this.profile === 'PROCUREMENT') {
        this.$router.push({name: 'vendorManagementRequestList', query: {request: notification.companyFormRequest.id}});
      } else if (notification.companyFormRequest.company.id === this.company.id && this.profile !== 'PROCUREMENT') {
        this.$router.push({
          name: 'vendorManagementOutgoingRequests',
          query: {request: notification.companyFormRequest.id}
        });
      } else {
        // other company request

        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("header.srgTdrkTrf", {name: notification.companyFormRequest.company.name}),
          icon: 'info',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t("requestCannotCommentOfferView.profilimiDyi"),
          cancelButtonText: this.$t("companyProfile.lvEt2")
        }).then((result) => {
          if (result.value) {
            this.$router.push({name: 'changeAccount'});
          }
        })

      }
    },
    formNotificationClick(notification) {
      if (notification.companyForm.company.id === this.company.id) {
        this.$router.push({name: 'vendorManagementFormManage', params: {id: notification.companyForm.id}});
      } else {
        this.$router.push({name :'vendorFormView', params: {id: notification.companyForm.id}});
        //
        // this.$swal({
        //   title: this.$t("generalModal.warningTitle"),
        //   text: this.$t("header.formaTarefinden"),
        //   icon: 'info',
        //   showCancelButton: true,
        //   confirmButtonColor: '#3085d6',
        //   cancelButtonColor: '#d33',
        //   confirmButtonText: this.$t("requestCannotCommentOfferView.profilimiDyi"),
        //   cancelButtonText: this.$t("companyProfile.lvEt2")
        // }).then((result) => {
        //   if (result.value) {
        //     this.$router.push({name: 'changeAccount'});
        //   }
        // })
      }
    },
    submitSearch() {
      if (this.terms && this.terms.length > 2) {

        this.$router.push({
          'name': 'search',
          query: {
            keyword: this.terms
          }
        })

      }
    }, getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
  }
}
</script>

<style scoped lang="scss">
.notification-item {
  cursor: pointer;

  .title {
    font-size: 14px;
    color: #2062FB;
    margin-bottom: 10px;
  }

  .body {
    font-size: 14px;
    color: #5D6B82;
    margin-bottom: 10px;
  }

  .time {
    font-size: 12px;
    color: #8B95A6;
  }

  .dott {
    width: 14px;
    height: 14px;
    background: #4D74E3;
    border-radius: 7px;
  }
}

.header-icon {
  height: 48px;
  width: 48px;
  padding: 12px;
  border-radius: 50%;
  background: rgba(#DEE5EF, 0.3);

  img {
    width: 24px;
    height: 24px;
  }

  &:hover {
    background: rgba(#DEE5EF, 0.5);
  }

}

.header-profile-icon {
  height: 48px;
  padding: 6px 12px 6px 6px;
  border-radius: 24px;
  background: rgba(#DEE5EF, 0.3);
  white-space: nowrap;

  img {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    margin-right: 10px;
    padding: 2px;
    border: 1px solid #acbbcb;
    background: white;
  }


  &:hover {
    background: rgba(#DEE5EF, 0.5);
  }


}
</style>
